import React from "react";

const SegmentTrack = (props) => {
  
  const memoizedSegmentsData = React.useMemo(() => {
    if(!props.segments_data) return([]);

    let tmpDatapoints =( props.segments_data.map( (datapoint, datapointIndex) => {

      let x_pos= -1;
      let percentX = 0;
      percentX = (datapoint.LOC_START- props.visibleWindow[0]+1 ) / (props.visibleWindow[1]-props.visibleWindow[0]);
      x_pos = Math.round(percentX * props.width );


      let x2_pos= -1;
      let percentX2 = 0;
      percentX2 = (datapoint.LOC_END - props.visibleWindow[0]+1 ) / (props.visibleWindow[1]-props.visibleWindow[0]);
      x2_pos = Math.round(percentX2 * props.width );

      let percentY = 0;
      let y_AxisLength = Math.abs(props.visibleWindow[3] - props.visibleWindow[2]);
      //* needs to get rounded to the nearest pixel!
      percentY=Math.abs(props.visibleWindow[3] - datapoint.SEG_MEAN )/y_AxisLength; // props.height
      let y_pos = Math.round(props.height*percentY);

      return(
        {
          X1_POS:x_pos,
          X2_POS:x2_pos,
          Y_POS:y_pos,
          LOC_START:datapoint.LOC_START,
          LOC_END:datapoint.LOC_END,
          SEG_MEAN:datapoint.SEG_MEAN,
          // IS_SELECTED:false
        }
      );
      }) 
    );
    return(tmpDatapoints);
  }, [props.segments_data, props.visibleWindow]);


  const renderSegments = () => {
    // Compute selected segment X coordinates globally
    const selectedOverlayCoords = props.selectedSegment
      ? (() => {
          const percentX = (props.selectedSegment.LOC_START - props.visibleWindow[0] + 1) /
                           (props.visibleWindow[1] - props.visibleWindow[0]);
          const percentX2 = (props.selectedSegment.LOC_END - props.visibleWindow[0] + 1) /
                            (props.visibleWindow[1] - props.visibleWindow[0]);
          return {
            X1_POS: Math.round(percentX * props.width),
            X2_POS: Math.round(percentX2 * props.width)
          };
        })()
      : null;
  
    // Check if current sample contains selected segment
    const sampleContainsSelected = memoizedSegmentsData.some(
      seg =>
        seg.LOC_START === props.selectedSegment?.LOC_START &&
        seg.LOC_END === props.selectedSegment?.LOC_END
    );
  
    // Map over existing segments
    const lollipops = memoizedSegmentsData.map((datapoint, idx) => {
      const isSelected =
        datapoint.LOC_START === props.selectedSegment?.LOC_START &&
        datapoint.LOC_END === props.selectedSegment?.LOC_END;
  
      if (!isFinite(datapoint.X1_POS) || !isFinite(datapoint.X2_POS)) return <g key={idx}></g>;
  
      const segLen = datapoint.X2_POS - datapoint.X1_POS;
  
      return (
        <g key={idx}>
          {isSelected && (
            <circle
              fill="none"
              stroke="red"
              strokeWidth="2"
              r={Math.max(10, segLen / 2 + 5)}
              cx={props.x + datapoint.X1_POS + segLen / 2}
              cy={props.y + datapoint.Y_POS}
            />
          )}
          <rect
            fill={isSelected ? "red" : "blue"}
            stroke={isSelected ? "red" : "none"}
            strokeWidth="1"
            x={props.x + datapoint.X1_POS}
            y={props.y + datapoint.Y_POS}
            width={segLen}
            height={2}
          />
        </g>
      );
    });
  
    // Add gray “fake” segment if sample does NOT contain it
    console.log('sampleContainsSelected',sampleContainsSelected)
    console.log('selectedOverlayCoords',selectedOverlayCoords)
    if (!sampleContainsSelected && selectedOverlayCoords) {
      const { X1_POS, X2_POS } = selectedOverlayCoords;
      const segLen = X2_POS - X1_POS;
    
      // Compute Y position for the selected segment in this sample
      const y_AxisLength = Math.abs(props.visibleWindow[3] - props.visibleWindow[2]);
      const percentY = Math.abs(props.visibleWindow[3] - props.selectedSegment.SEG_MEAN) / y_AxisLength;
      const y_pos = Math.round(props.height * percentY);
    
      lollipops.push(
        <g key="fake-selected-segment">
          <circle
            fill="none"
            stroke="red"
            strokeDasharray="4,3"
            strokeWidth="2"
            r={Math.max(10, segLen / 2 + 5)}
            cx={props.x + X1_POS + segLen / 2}
            cy={props.y + y_pos} // Y matches SEG_MEAN
          />
          {/* <rect
            fill="red"
            opacity="0.4"
            x={props.x + X1_POS}
            y={props.y + y_pos} // Y matches SEG_MEAN
            width={segLen}
            height={2}
          /> */}
        </g>
      );
    }
  
    return <g>{lollipops}</g>;
  };

  return(
    <g>
      {renderSegments()}

    </g>
  );

}

export default SegmentTrack;
